import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useUserContext } from "../utils/hooks/UserContext";
import { useBanner } from "../utils/context/BannerContext";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NotificationDropdown from "./NotificationDropdown";
import MenuItemsT from "./ProfileDropdown";

const defaultNavigation = [
  { name: "About Us", href: "/about", current: false },
  { name: "Community Feed", href: "/activity-stream", current: false },
  { name: "Browse Coach", href: "/browse-coach/grid-view", current: false },
  { name: "Become a Coach", href: "/become-a-coach", current: false },
  { name: "Blogs", href: "/blogs", current: false },
];

const userNavigation = [
  { name: "About Us", href: "/about", current: false },
  { name: "Browse Coach", href: "/browse-coach/grid-view", current: false },
  { name: "Community Feed", href: "/activity-stream", current: false },
  // { name: "Become a Coach", href: "/become-a-coach", current: false },
  { name: "Blogs", href: "/blogs", current: false },
];

const coachNavigation = [
  { name: "About Us", href: "/about", current: false },
  { name: "Browse Coach", href: "/browse-coach/grid-view", current: false },
  { name: "Community Feed", href: "/activity-stream", current: false },
  { name: "Blogs", href: "/blogs", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TailwindNavbar({ sidebarOpen = false, onToggleSidebar = () => { }, isMobileView: isMobileViewProp = false }) {
  const { user, handleLogout } = useUserContext();
  const { isBannerVisible } = useBanner();
  const [navigation, setNavigation] = useState([]);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const { pathname } = useLocation();
  const [activeMenu, setActiveMenu] = useState(
    JSON.parse(localStorage.getItem("navigation")) || "/"
  );
  const navigate = useNavigate();
  const navbarTop = isBannerVisible ? "top-[44px]" : "top-0";
  const [scrolled, setScrolled] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1050);
  const isSidebarMobileView = isMobileViewProp || window.innerWidth < 768;

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1050);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [scrolled]);

  useEffect(() => {
    console.log("User type:", user?.userType);

    if (user?.userType === "coach") {
      setNavigation(coachNavigation);
    } else if (user?.userType === "user") {
      setNavigation(userNavigation);
    } else {
      setNavigation(defaultNavigation);
    }
  }, [user]);

  const getImage = (image) => {
    if (image) {
      if (user?.userType === "user") {
        return `${process.env.REACT_APP_USER_PROFILE_FOLDER_PATH}${image}`;
      } else if (user?.userType === "coach") {
        return `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${image}`;
      }
    } else {
      return "/default.avif";
    }
  };

  // useEffect(() => {
  //   if (pathname === "/") {
  //     localStorage.setItem("navigation", JSON.stringify("/"));
  //     setActiveMenu("/");
  //   }

  //   const matchedNav = defaultNavigation.find((item) => item.href === pathname);
  //   if (matchedNav) {
  //     localStorage.setItem("navigation", JSON.stringify(matchedNav.href));
  //     setActiveMenu(matchedNav.href);
  //   }
  // }, [pathname]);
  useEffect(() => {
    let newMenu = "/";
    if (pathname !== "/") {
      const matchedNav = defaultNavigation.find(
        (item) => item.href === pathname
      );
      if (matchedNav) {
        newMenu = matchedNav.href;
      }
    }

    if (activeMenu !== newMenu) {
      localStorage.setItem("navigation", JSON.stringify(newMenu));
      setActiveMenu(newMenu);
    }
  }, [pathname, activeMenu]);

  return (
    <Disclosure
      as="nav"
      className={`bg-[#fbf3e4] border-b border-[#cccccc5b] fixed ${navbarTop} left-0 right-0 w-full z-[9999] transition-all duration-300 ${scrolled ? "shadow-md" : ""
        }`}
    >
      <div className="container mx-auto p-0">
        <div className="relative flex items-center justify-between h-16">
          <div className="relative flex items-center w-full h-16">
            <div className="inset-y-0 left-0 flex items-center lg:hidden">
              {/* Navbar disclosure button */}
              <DisclosureButton className="relative inline-flex items-center justify-center p-2 text-gray-400 rounded-md group hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <Bars3Icon
                  aria-hidden="true"
                  className="block size-6 group-data-[open]:hidden"
                />
                <XMarkIcon
                  aria-hidden="true"
                  className="hidden size-6 group-data-[open]:block"
                />
              </DisclosureButton>
            </div>
            <div className={`flex items-center justify-start`}>
              <div className="flex items-center shrink-0">
                <Link to="/">
                  <img
                    alt="Company Logo"
                    src="/logo_dark.png"
                    className="w-[144px] h-[35px] md:h-[42px] object-contain"
                    onClick={() => {
                      localStorage.setItem("navigation", JSON.stringify("/"));
                      setActiveMenu("/");
                    }}
                  />
                </Link>
              </div>
            </div>

            <div className="hidden transition-all duration-200 ease-in-out lg:ml-6 lg:block">
              <div className="flex items-center transition-all duration-200 ease-in-out">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={
                      !user &&
                        (item.name === "Browse Coach" ||
                          item.name === "Community Feed")
                        ? "/login"
                        : item.href
                    }
                    className={classNames(
                      activeMenu === item.href
                        ? "bg-transparent border-b-2 border-[#00504E] text-[#00504E] font-bold scale-[1.02]"
                        : "text-gray-600 hover:text-[#00504E] hover:scale-[1.02]",
                      "font-medium hover:scale-110 hover:text-[#00504E] px-4 py-2 text-sm transition-all duration-200 ease-in-out transform"
                    )}
                    onClick={() => {
                      setActiveMenu(item.href);

                      if (
                        !user &&
                        (item.name === "Browse Coach" ||
                          item.name === "Activity Stream")
                      ) {
                        navigate("/login");
                      }
                    }}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0">
            {user ? (
              <>
                <NotificationDropdown />
                {/* Profile dropdown - commented out for future use */}
                {/* <Menu as="div" className="relative ml-3">
                  <div>
                    <MenuButton
                      onClick={() => setProfileDropdown(!profileDropdown)}
                      className="relative w-[2.8rem] h-[2.8rem] flex text-sm bg-gray-800 rounded-full"
                    >
                      <span className="absolute -inset-1.5" />
                      <img
                        alt=""
                        src={getImage(user?.profile_pic)}
                        className="object-cover border-2 border-[#0f5c5b] w-full h-full rounded-full size-8"
                      />
                    </MenuButton>
                  </div>
                  <MenuItemsT
                    user={user}
                    handleLogout={handleLogout}
                    isOpen={profileDropdown}
                    setProfileDropdown={setProfileDropdown}
                  />
                </Menu> */}

                {/* Profile button - toggles sidebar on mobile, navigates to profile on desktop */}
                <div className="relative ml-3">
                  <button
                    onClick={() => {
                      // On mobile, toggle sidebar
                      if (isSidebarMobileView) {
                        onToggleSidebar();
                      } else {
                        // On desktop, navigate to profile page based on user type
                        if (user?.userType === "coach") {
                          navigate("/coach/profile");
                        } else if (user?.userType === "user") {
                          navigate("/user/profile");
                        }
                      }
                    }}
                    className="relative w-[2.8rem] h-[2.8rem] flex text-sm bg-gray-800 rounded-full cursor-pointer hover:opacity-80 transition-opacity"
                    aria-label={isSidebarMobileView ? (sidebarOpen ? "Close sidebar" : "Open sidebar") : "Go to profile"}
                  >
                    <span className="absolute -inset-1.5" />
                    <img
                      alt=""
                      src={getImage(user?.profile_pic)}
                      className="object-cover border-2 border-[#0f5c5b] w-full h-full rounded-full size-8"
                    />
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-1">
                <button
                  onClick={() => navigate("/login")}
                  className="flex items-center justify-center h-[32px] w-[85px] px-8 rounded-lg bg-transparent text-[#00504E] font-medium text-[16px] leading-[150%] hover:bg-[#00504E]/10 transition-all duration-200"
                  style={{ fontFamily: 'Poppins', border: '1px solid rgba(0, 80, 78, 1)' }}
                >
                  Login
                </button>
                <span className="text-2xl text-gray-800 font-light">|</span>
                <button
                  onClick={() => navigate("/signup")}
                  className="flex items-center justify-center h-[32px] w-[85px] px-8 rounded-lg bg-transparent text-[#964B00] font-medium text-[16px] leading-[150%] hover:bg-[#964B00]/10 transition-all duration-200"
                  style={{ fontFamily: 'Poppins', border: '1px solid rgba(150, 75, 0, 1)' }}
                >
                  Signup
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <DisclosurePanel className="">
        <div className="flex flex-col px-2 pt-2 pb-3 space-y-1 transition-all duration-150">
          {(isMobileView || scrolled) &&
            navigation.map((item) => (
              <Link
                key={item.name}
                to={
                  !user &&
                    (item.name === "Browse Coach" ||
                      item.name === "Community Feed")
                    ? "/login"
                    : item.href
                }
                className={classNames(
                  activeMenu === item.href
                    ? "bg-transparent border-b-2 border-[#00504E] text-[#00504E] font-bold"
                    : "text-gray-600 hover:text-[#00504E] hover:scale-[1.01]",
                  "font-medium hover:font-bold px-4 py-2 text-sm transition-all duration-200 bg-[#FBF3E4] ease-in-out transform"
                )}
                onClick={() => {
                  setActiveMenu(item.href);
                  localStorage.setItem("navigation", JSON.stringify(item.href));

                  if (
                    !user &&
                    (item.name === "Browse Coach" ||
                      item.name === "Activity Stream")
                  ) {
                    navigate("/login");
                  }
                }}
              >
                {item.name}
              </Link>
            ))}
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}
